import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';

import { AADAuthenticationService } from './aadauthentication.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationGuard implements CanActivate {

    constructor(
        private authenticationService: AADAuthenticationService,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.authenticationService.isLoggedIn())
            return true;

        this.router.navigate(['/login']), {
            queryParams: {
                accessDenied: true
            }
        };
        return false;
    }
}